import DomainSettings from './domain';
import SiteSettings from './site-settings';

export interface ISettingTab {
  name: string;
  key: string;
  title: string;
  icon: React.ReactNode;
  component: React.ReactNode;
}

export const tabs: ISettingTab[] = [
  {
    name: 'Site settings',
    key: 'site-settings',
    title: 'Site Settings',
    icon: (
      <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M2.5 3.5L2.5 13.5C2.5 13.7761 2.72386 14 3 14H13C13.2761 14 13.5 13.7761 13.5 13.5V3.5C13.5 3.22386 13.2761 3 13 3H3C2.72386 3 2.5 3.22386 2.5 3.5Z"
          stroke="#F3F4F6"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.75 6.75H9.75V9.75"
          stroke="#F3F4F6"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.25 10.25L9.75 6.75"
          stroke="#F3F4F6"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    component: <SiteSettings />,
  },
  {
    name: 'Domain',
    key: 'domain-settings',
    title: 'Domains',
    icon: (
      <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M13.9289 9.43057L13.1722 8.67391C13.0583 8.55982 12.9635 8.42813 12.8915 8.28391L12.1715 6.84391C12.1519 6.80482 12.1233 6.77096 12.0881 6.74509C12.0528 6.71923 12.0119 6.70211 11.9688 6.69514C11.9256 6.68818 11.8814 6.69156 11.8398 6.70503C11.7982 6.71849 11.7604 6.74164 11.7295 6.77257C11.66 6.84205 11.5731 6.89167 11.4779 6.91629C11.3827 6.9409 11.2827 6.93962 11.1882 6.91257L10.3395 6.67057C10.2037 6.6324 10.0588 6.64385 9.9307 6.70286C9.80259 6.76188 9.6997 6.8646 9.64047 6.99261C9.58124 7.12062 9.56955 7.26554 9.60749 7.40139C9.64544 7.53723 9.73054 7.65512 9.84753 7.73391L10.2389 7.99391C10.6322 8.25724 10.6882 8.81391 10.3535 9.14857L10.2202 9.28191C10.0789 9.42324 10.0002 9.61391 10.0002 9.81257V10.0859C10.0002 10.3586 9.92686 10.6252 9.78686 10.8579L8.9102 12.3186C8.78523 12.527 8.60839 12.6995 8.39692 12.8193C8.18545 12.939 7.94656 13.0019 7.70353 13.0019C7.517 13.0019 7.3381 12.9278 7.2062 12.7959C7.0743 12.664 7.0002 12.4851 7.0002 12.2986V11.5172C7.0002 10.9039 6.62686 10.3526 6.05753 10.1246L5.62086 9.95057C5.30316 9.82339 5.03849 9.5914 4.87078 9.29309C4.70307 8.99479 4.64241 8.6481 4.69886 8.31057L4.70353 8.28257C4.73452 8.09711 4.8001 7.91913 4.89686 7.75791L4.95686 7.65791C5.11608 7.39278 5.35334 7.18334 5.63618 7.05827C5.91902 6.9332 6.23361 6.89861 6.53686 6.95924L7.3222 7.11657C7.507 7.15343 7.69892 7.11937 7.85975 7.02117C8.02059 6.92296 8.13856 6.76781 8.1902 6.58657L8.32886 6.09991C8.3769 5.93178 8.36468 5.75215 8.29432 5.59207C8.22396 5.43199 8.09988 5.30153 7.94353 5.22324L7.5002 5.00191L7.43953 5.06257C7.30024 5.20186 7.13488 5.31235 6.95289 5.38773C6.7709 5.46311 6.57585 5.50191 6.37886 5.50191H6.25886C6.09286 5.50191 5.9342 5.56857 5.81753 5.68457C5.71061 5.79246 5.56783 5.8574 5.41624 5.86708C5.26466 5.87677 5.11478 5.83052 4.995 5.73711C4.87522 5.6437 4.79385 5.50961 4.7663 5.36023C4.73876 5.21086 4.76695 5.05656 4.84553 4.92657L5.7862 3.35791C5.87995 3.20198 5.94456 3.03029 5.97686 2.85124M13.9289 9.43057C14.0903 8.402 13.9814 7.3491 13.6127 6.37539C13.244 5.40168 12.6283 4.54066 11.8261 3.87698C11.0239 3.2133 10.0627 2.7698 9.03718 2.59007C8.01164 2.41034 6.95697 2.50058 5.97686 2.85191C4.97974 3.20933 4.09502 3.82435 3.4126 4.63448C2.73017 5.4446 2.27438 6.42094 2.09153 7.46429C1.90869 8.50763 2.00531 9.58078 2.37158 10.5747C2.73784 11.5686 3.3607 12.4478 4.17685 13.123C4.99301 13.7982 5.97336 14.2453 7.01828 14.4189C8.06321 14.5925 9.13547 14.4863 10.1261 14.1112C11.1167 13.7362 11.9904 13.1055 12.6583 12.2834C13.3262 11.4613 13.7646 10.477 13.9289 9.43057Z"
          stroke="#F3F4F6"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    ),
    component: <DomainSettings />,
  },
];
